/* eslint-disable react/destructuring-assignment */
import React from 'react';
import Button from '@mui/material/Button';
import type { ButtonProps } from '@mui/material';

export default function SecondaryButton2(props: ButtonProps): JSX.Element {
  return (
    <Button
      className='secondary-btn-2'
      color='secondary'
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {props.children}
    </Button>
  );
}
